import { c as _c } from "react/compiler-runtime";
import { AboutSection } from "@/enums";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./About.module.scss";
export default function AboutPrivacyPolicy() {
  const $ = _c(122);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>Privacy Policy</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Row><Col className={`${styles.lastUpdateText} text-right pt-3 pb-3`}>Last Updated: February 23, 2023</Col></Row>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <b>Seize</b>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <b>we</b>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <b>our</b>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p>This Privacy Policy describes how 6529 Collection LLC d/b/a 6529.io ("{t2}", "{t3}", "{t4}") processes personal information that we collect through our digital or online properties or services that link to this Privacy Policy (including as applicable, our website, social media pages, live events and other activities described in this Privacy Policy (collectively, the " <b>Service</b>")).</p>;
    t6 = <br />;
    t7 = <h3>Index</h3>;
    t8 = <br />;
    t9 = <br />;
    t10 = <ul><li>Personal information we collect</li><li>How we use your personal information</li><li>How we share your personal information</li><li>Your choices</li><li>Other sites and services</li><li>Security</li><li>International data transfers</li><li>Children</li><li>Changes to this Privacy Policy</li><li>How to contact us</li></ul>;
    t11 = <br />;
    t12 = <h3>Personal information we collect</h3>;
    t13 = <br />;
    t14 = <br />;
    t15 = <p><b>Information you provide to us.</b> Personal information you may provide to us through the Service or otherwise includes:</p>;
    t16 = <ul><li><b>Transactional data</b>, when you connect your Ethereum wallet to our website or minting pages, we read your public wallet data such as your Ethereum addresses and which tokens you have in your address in order to display those tokens on our Service or to allow you to mint an NFT on or through the Service. It is not possible to mint an NFT without connecting an Ethereum wallet in this manner.</li><li><b>Communications data</b> based on our exchanges with you, including when you contact us through the Service, social media, or otherwise.</li><li><b>Other data</b> not specifically listed here, which we will use as described in this Privacy Policy or as otherwise disclosed at the time of collection.</li></ul>;
    t17 = <p><b>Third-party sources.</b>We may combine personal information we receive from you with public or personal information we may obtain from other sources, such as:</p>;
    t18 = <li><b>Public blockchains:</b> we obtain publicly available information about NFTs, NFT transactions and addresses from public blockchains like Ethereum. As a non-exclusive example, we display on our website which Ethereum addresses own our NFTs.</li>;
    t19 = <li><b>Social Media platforms:</b> social media platforms, and other publicly available sources. As a non-exclusive example, you may contact us on Twitter and we might learn your name from your Twitter public profile.</li>;
    t20 = <b>Third-party services:</b>;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t14;
    $[10] = t15;
    $[11] = t16;
    $[12] = t17;
    $[13] = t18;
    $[14] = t19;
    $[15] = t20;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t13 = $[8];
    t14 = $[9];
    t15 = $[10];
    t16 = $[11];
    t17 = $[12];
    t18 = $[13];
    t19 = $[14];
    t20 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t21;
  let t22;
  let t23;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <ul>{t18}{t19}<li>{t20} such as virtual currency account services you link to the Services. This data may include your wallet address or other information associated with that account that is made available to us based on your account settings on that service.<br />As a non-exclusive example, when you connect your Ethereum wallet to our website, it shares your wallet address with us.</li></ul>;
    t22 = <p><b>Automatic data collection.</b> We, our service providers, and our business partners may automatically log information about you, your computer or mobile device, and your interaction over time with the Service, our communications and other online services, such as:</p>;
    t23 = <b>Device data</b>;
    $[21] = t21;
    $[22] = t22;
    $[23] = t23;
  } else {
    t21 = $[21];
    t22 = $[22];
    t23 = $[23];
  }
  let t24;
  let t25;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <ul><li>{t23}, such as your computer or mobile device's operating system type and version, manufacturer and model, browser type, screen resolution, RAM and disk size, CPU usage, device type (e.g., phone, tablet), IP address, unique identifiers (including identifiers used for advertising purposes), language settings, mobile device carrier, radio/network information (e.g., Wi-Fi, LTE, 3G), and general location information such as city, state or geographic area.<br />As a non-exclusive example, we may serve a version of our webpage appropriate to the size of your screen.</li><li><b>Online activity data</b>, such as pages or screens you viewed, how long you spent on a page or screen, the website you visited before browsing to the Service, navigation paths between pages or screens, information about your activity on a page or screen, access times and duration of access, and whether you have opened our emails or clicked links within them.</li></ul>;
    t25 = <b>Cookies.</b>;
    $[24] = t24;
    $[25] = t25;
  } else {
    t24 = $[24];
    t25 = $[25];
  }
  let t26;
  let t27;
  let t28;
  let t29;
  let t30;
  let t31;
  let t32;
  let t33;
  let t34;
  let t35;
  let t36;
  let t37;
  let t38;
  let t39;
  let t40;
  let t41;
  let t42;
  let t43;
  let t44;
  let t45;
  let t46;
  let t47;
  let t48;
  let t49;
  let t50;
  let t51;
  let t52;
  let t53;
  let t54;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <p>{t25} Some of our automatic data collection is facilitated by cookies and similar technologies. For more information, see our{" "}<Link href={`/about/${AboutSection.COOKIE_POLICY}`}>Cookie Policy</Link>. We may also store a record of your preferences in respect of the use of these technologies in connection with the Service.</p>;
    t27 = <br />;
    t28 = <h3>How we use your personal information</h3>;
    t29 = <br />;
    t30 = <br />;
    t31 = <p>We may use your personal information for the following purposes or as otherwise described at the time of collection:</p>;
    t32 = <p><b>Service delivery and operations.</b> We may use your personal information to:</p>;
    t33 = <ul><li>provide, operate and improve the Service and our business;</li><li>personalize the service, including remembering your selections and preferences as you navigate the Service;</li><li>enable you to mint an NFT;</li><li>communicate with you about the Service, including by sending Service-related announcements, updates, security alerts, and support and administrative messages;</li><li>understand your needs and interests, and personalize your experience with the Service and our communications; and</li><li>provide support for the Service, and respond to your requests, questions and feedback.</li></ul>;
    t34 = <p><b>Research and development.</b> We may use your personal information for research and development purposes, including to analyze and improve the Service and our business and to develop new products and services. As part of these activities, we may create aggregated, de-identified and/or anonymized data from personal information we collect. We make personal information into de-identified or anonymized data by removing information that makes the data personally identifiable to you. We may use this aggregated, de-identified or otherwise anonymized data and share it with third parties for our lawful business purposes, including to analyze and improve the Service and promote our business and will not attempt to reidentify any such data.</p>;
    t35 = <p><b>Service improvement and analytics.</b> We may use your personal information to analyze your usage of the Service, improve the Service, improve the rest of our business, help us understand user activity on the Service, including which pages are most and least visited and how visitors move around the Service, as well as user interactions with our emails, and to develop new products and services.</p>;
    t36 = <p><b>Compliance and protection.</b> We may use your personal information to:</p>;
    t37 = <ul><li>comply with applicable laws, lawful requests, and legal process, such as to respond to subpoenas, investigations or requests from government authorities;</li><li>protect our, your or others' rights, privacy, safety or property (including by making and defending legal claims);</li><li>audit our internal processes for compliance with legal and contractual requirements or our internal policies;</li><li>enforce the terms and conditions that govern the Service; and</li><li>prevent, identify, investigate and deter fraudulent, harmful, unauthorized, unethical or illegal activity, including cyberattacks and identity theft.</li></ul>;
    t38 = <p><b>With your consent.</b> In some cases, we may specifically ask for your consent to collect, use or share your personal information, such as when required by law.</p>;
    t39 = <br />;
    t40 = <h3>How we share your personal information</h3>;
    t41 = <br />;
    t42 = <br />;
    t43 = <p>We may share your personal information with the following parties and as otherwise described in this Privacy Policy, in other applicable notices, or at the time of collection.</p>;
    t44 = <p><b>Affiliates.</b> Our corporate parent, subsidiaries, and affiliates.</p>;
    t45 = <p><b>Service providers.</b> Third parties that provide services on our behalf or help us operate the Service or our business (such as hosting, information technology, customer support, and website analytics).</p>;
    t46 = <p><b>Professional advisors.</b> Professional advisors, such as lawyers, auditors, bankers and insurers, where necessary in the course of the professional services that they render to us.</p>;
    t47 = <p><b>Authorities and others.</b> Law enforcement, government authorities, and private parties, as we believe in good faith to be necessary or appropriate for the Compliance and protection purposes described above.</p>;
    t48 = <p><b>Business transferees.</b> We may disclose personal information in the context of actual or prospective business transactions (e.g., investments in or sale of our company), for example, we may need to share certain personal information with prospective counterparties and their advisers. We may also disclose your personal information to an acquirer, successor, or assignee of 6529 Collections as part of any merger, acquisition, sale of assets, or similar transaction, and/or in the event of an insolvency, bankruptcy, or receivership in which personal information is transferred to one or more third parties as one of our business assets.</p>;
    t49 = <p><b>Other users and the public.</b> Your transactional data is visible to other users of the Service and the public, including on the Ethereum blockchain, directly on Ethereum nodes and on a wide variety of websites and services that read directly from the Ethereum blockchain. This information can be seen, collected and used by others, including being cached, copied, screen captured or stored elsewhere by others (e.g., search engines), and we are not responsible for any such use of this information.</p>;
    t50 = <br />;
    t51 = <h3>Your choices</h3>;
    t52 = <br />;
    t53 = <br />;
    t54 = <b>Cookies.</b>;
    $[26] = t26;
    $[27] = t27;
    $[28] = t28;
    $[29] = t29;
    $[30] = t30;
    $[31] = t31;
    $[32] = t32;
    $[33] = t33;
    $[34] = t34;
    $[35] = t35;
    $[36] = t36;
    $[37] = t37;
    $[38] = t38;
    $[39] = t39;
    $[40] = t40;
    $[41] = t41;
    $[42] = t42;
    $[43] = t43;
    $[44] = t44;
    $[45] = t45;
    $[46] = t46;
    $[47] = t47;
    $[48] = t48;
    $[49] = t49;
    $[50] = t50;
    $[51] = t51;
    $[52] = t52;
    $[53] = t53;
    $[54] = t54;
  } else {
    t26 = $[26];
    t27 = $[27];
    t28 = $[28];
    t29 = $[29];
    t30 = $[30];
    t31 = $[31];
    t32 = $[32];
    t33 = $[33];
    t34 = $[34];
    t35 = $[35];
    t36 = $[36];
    t37 = $[37];
    t38 = $[38];
    t39 = $[39];
    t40 = $[40];
    t41 = $[41];
    t42 = $[42];
    t43 = $[43];
    t44 = $[44];
    t45 = $[45];
    t46 = $[46];
    t47 = $[47];
    t48 = $[48];
    t49 = $[49];
    t50 = $[50];
    t51 = $[51];
    t52 = $[52];
    t53 = $[53];
    t54 = $[54];
  }
  let t55;
  let t56;
  let t57;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <p>{t54} For information about cookies employed by the Service and how to control them, see our{" "}<Link href={`/about/${AboutSection.COOKIE_POLICY}`}>Cookie Policy</Link>.</p>;
    t56 = <p><b>Blocking images/clear gifs:</b> Most browsers and devices allow you to configure your device to prevent images from loading. To do this, follow the instructions in your particular browser or device settings.</p>;
    t57 = <b>Do Not Track.</b>;
    $[55] = t55;
    $[56] = t56;
    $[57] = t57;
  } else {
    t55 = $[55];
    t56 = $[56];
    t57 = $[57];
  }
  let t58;
  let t59;
  let t60;
  let t61;
  let t62;
  let t63;
  let t64;
  let t65;
  let t66;
  let t67;
  let t68;
  let t69;
  let t70;
  let t71;
  let t72;
  let t73;
  let t74;
  let t75;
  let t76;
  let t77;
  let t78;
  let t79;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = <p>{t57} Some Internet browsers may be configured to send "Do Not Track" signals to the online services that you visit. We currently do not respond to "Do Not Track" signals. To find out more about "Do Not Track," please visit{" "}<a href="http://www.allaboutdnt.com" target="_blank" rel="noopener noreferrer">http://www.allaboutdnt.com</a>.</p>;
    t59 = <p><b>Declining to provide information.</b> We need to collect personal information to provide certain services. If you do not provide the information we identify as required or mandatory, we may not be able to provide those services.</p>;
    t60 = <p><b>Linked third-party platforms.</b> If you choose to connect to the Service through a third-party platform, such as a virtual currency account service that you link to the Services, you may be able to use your settings in your account with that platform to limit the information we receive from it. If you revoke our ability to access information from a third-party platform, that choice will not apply to information that we have already received from that third party.</p>;
    t61 = <br />;
    t62 = <h3>Other sites and services</h3>;
    t63 = <br />;
    t64 = <br />;
    t65 = <p>The Service may contain links to websites, mobile applications, and other online services operated by third parties. In addition, our content may be integrated into web pages or other online services that are not associated with us. These links and integrations are not an endorsement of, or representation that we are affiliated with, any third party. We do not control websites, mobile applications or online services operated by third parties, and we are not responsible for their actions. We encourage you to read the privacy policies of the other websites, mobile applications and online services you use.</p>;
    t66 = <br />;
    t67 = <h3>Security</h3>;
    t68 = <br />;
    t69 = <br />;
    t70 = <p>We employ a number of technical, organizational and physical safeguards designed to protect the personal information we collect. However, security risk is inherent in all internet and information technologies, and we cannot guarantee the security of your personal information.</p>;
    t71 = <br />;
    t72 = <h3>International data transfer</h3>;
    t73 = <br />;
    t74 = <br />;
    t75 = <p>We and our service providers may operate and process your personal information in various countries. Your personal information may be transferred to the United States or other locations where privacy laws may vary and not be as protective as those in your state, province, or country.</p>;
    t76 = <br />;
    t77 = <h3>Children</h3>;
    t78 = <br />;
    t79 = <br />;
    $[58] = t58;
    $[59] = t59;
    $[60] = t60;
    $[61] = t61;
    $[62] = t62;
    $[63] = t63;
    $[64] = t64;
    $[65] = t65;
    $[66] = t66;
    $[67] = t67;
    $[68] = t68;
    $[69] = t69;
    $[70] = t70;
    $[71] = t71;
    $[72] = t72;
    $[73] = t73;
    $[74] = t74;
    $[75] = t75;
    $[76] = t76;
    $[77] = t77;
    $[78] = t78;
    $[79] = t79;
  } else {
    t58 = $[58];
    t59 = $[59];
    t60 = $[60];
    t61 = $[61];
    t62 = $[62];
    t63 = $[63];
    t64 = $[64];
    t65 = $[65];
    t66 = $[66];
    t67 = $[67];
    t68 = $[68];
    t69 = $[69];
    t70 = $[70];
    t71 = $[71];
    t72 = $[72];
    t73 = $[73];
    t74 = $[74];
    t75 = $[75];
    t76 = $[76];
    t77 = $[77];
    t78 = $[78];
    t79 = $[79];
  }
  let t100;
  let t101;
  let t80;
  let t81;
  let t82;
  let t83;
  let t84;
  let t85;
  let t86;
  let t87;
  let t88;
  let t89;
  let t90;
  let t91;
  let t92;
  let t93;
  let t94;
  let t95;
  let t96;
  let t97;
  let t98;
  let t99;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t80 = <p>The Service is not intended for use by anyone under 18 years of age. If you are a parent or guardian of a child from whom you believe we have collected personal information in a manner prohibited by law, please{" "}<Link href={`/about/${AboutSection.CONTACT_US}`}>contact us</Link>. If we learn that we have collected personal information through the Service from a child without the consent of the child's parent or guardian as required by law, we will comply with applicable legal requirements to delete the information.</p>;
    t81 = <br />;
    t82 = <h3>Changes to this Privacy Policy</h3>;
    t83 = <br />;
    t84 = <br />;
    t85 = <p>We reserve the right to modify this Privacy Policy at any time. If we make material changes to this Privacy Policy, we will notify you by updating the date of this Privacy Policy and posting it on the Service or other appropriate means. Any modifications to this Privacy Policy will be effective upon our posting the modified version (or as otherwise indicated at the time of posting). In all cases, your use of the Service after the effective date of any modified Privacy Policy indicates your acknowledging that the modified Privacy Policy applies to your interactions with the Service and our business.</p>;
    t86 = <br />;
    t87 = <h3>European Union residents / Your Rights</h3>;
    t88 = <br />;
    t89 = <br />;
    t90 = <p>We have taken all appropriate measures to provide any information relating to your rights as well as how to exercise these rights. Under Chapter III of the GDPR you have the following rights:</p>;
    t91 = <br />;
    t92 = <p><b>Transparent information, communication and modalities for the exercise of your rights</b><br />You have the right to be provided with your data freely and in an intelligible and easily accessible form. Following your request, we shall provide information without undue delay and in any event within one month of receipt of the request. That period may be extended where necessary, taking into account the complexity and number of requests. In that case we will inform you for the reasons of the delay.</p>;
    t93 = <br />;
    t94 = <p><b>Information to be provided where personal data are collected from the data subject</b><br />You have the right to know the contact details of the agent who collects your data, the purposes of the processing for which the personal data are intended, the legal basis for the processing, the recipients or categories of recipients of the personal data and where applicable the fact that the controller intends to transfer personal data to a third country.</p>;
    t95 = <br />;
    t96 = <p><b>Right of access</b><br />You have the right to request and receive a copy of your personal data undergoing processing. However, for any further copies requested, we may charge you a reasonable fee that is based on administrative costs.</p>;
    t97 = <br />;
    t98 = <p><b>Right to rectification</b><br />You have the right to obtain from us within reasonable time the rectification of inaccurate personal data concerning you.</p>;
    t99 = <br />;
    t100 = <b>Right to erasure ('right to be forgotten')</b>;
    t101 = <br />;
    $[80] = t100;
    $[81] = t101;
    $[82] = t80;
    $[83] = t81;
    $[84] = t82;
    $[85] = t83;
    $[86] = t84;
    $[87] = t85;
    $[88] = t86;
    $[89] = t87;
    $[90] = t88;
    $[91] = t89;
    $[92] = t90;
    $[93] = t91;
    $[94] = t92;
    $[95] = t93;
    $[96] = t94;
    $[97] = t95;
    $[98] = t96;
    $[99] = t97;
    $[100] = t98;
    $[101] = t99;
  } else {
    t100 = $[80];
    t101 = $[81];
    t80 = $[82];
    t81 = $[83];
    t82 = $[84];
    t83 = $[85];
    t84 = $[86];
    t85 = $[87];
    t86 = $[88];
    t87 = $[89];
    t88 = $[90];
    t89 = $[91];
    t90 = $[92];
    t91 = $[93];
    t92 = $[94];
    t93 = $[95];
    t94 = $[96];
    t95 = $[97];
    t96 = $[98];
    t97 = $[99];
    t98 = $[100];
    t99 = $[101];
  }
  let t102;
  let t103;
  let t104;
  let t105;
  let t106;
  let t107;
  let t108;
  let t109;
  let t110;
  let t111;
  let t112;
  let t113;
  let t114;
  let t115;
  let t116;
  if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
    t102 = <p>{t100}{t101}There is a right to ask for the erasure of your personal data and no longer processed where the personal data are no longer necessary in relation to the purposes for which they are controlled or otherwise processed.<br /><br />Thus, in the cases where we retain and process personal data in accordance with the provisions of Article 6(1)(c) of the GDPR, we may object to such a request and may keep the relevant personal data that are required in order for our us to comply with its legal obligations or the legal obligations of a Controller that cooperates with our us pursuant to the terms of a Data Processing Agreement.</p>;
    t103 = <br />;
    t104 = <p><b>Right to restriction of processing</b><br />We ensure that we have in place a procedure where you have the right to restrict the processing of your personal data. Nonetheless, for those personal data that are necessary for compliance with a legal obligation, we may object to the restriction.</p>;
    t105 = <br />;
    t106 = <p><b>Right to data portability</b><br />You have the right to receive the personal data concerning you, which you have provided to us, in a structured, commonly used and machine-readable format and you have the right to transmit those data to another controller without hindrance from the controller to which the personal data have been provided.</p>;
    t107 = <br />;
    t108 = <p><b>Right to object</b><br />You have the right to object to the processing of your personal data. However, since we lawfully process such data under Article 6(1)(c), we will still have the right to process the data.</p>;
    t109 = <br />;
    t110 = <p><b>Automated individual decision-making, including profiling</b><br />You have the right to be subject to a decision solely on automated processing, including profiling, which produces legal effects concerning you or similarly significantly affects you.</p>;
    t111 = <br />;
    t112 = <p><b>Ethereum blockchain data</b><br />For avoidance of doubt, we consider that information about Ethereum addresses, ENS names, tokens and token transactions on the Ethereum blockchain and similar public blockchains, is public data and we may store, process or display it without limitation.</p>;
    t113 = <br />;
    t114 = <h3>How to contact us</h3>;
    t115 = <br />;
    t116 = <br />;
    $[102] = t102;
    $[103] = t103;
    $[104] = t104;
    $[105] = t105;
    $[106] = t106;
    $[107] = t107;
    $[108] = t108;
    $[109] = t109;
    $[110] = t110;
    $[111] = t111;
    $[112] = t112;
    $[113] = t113;
    $[114] = t114;
    $[115] = t115;
    $[116] = t116;
  } else {
    t102 = $[102];
    t103 = $[103];
    t104 = $[104];
    t105 = $[105];
    t106 = $[106];
    t107 = $[107];
    t108 = $[108];
    t109 = $[109];
    t110 = $[110];
    t111 = $[111];
    t112 = $[112];
    t113 = $[113];
    t114 = $[114];
    t115 = $[115];
    t116 = $[116];
  }
  let t117;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t117 = <li>Email:{" "}<a href="mailto:privacy@6529.io" target="_blank" rel="noopener noreferrer">privacy@6529.io</a></li>;
    $[117] = t117;
  } else {
    t117 = $[117];
  }
  let t118;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t118 = <br />;
    $[118] = t118;
  } else {
    t118 = $[118];
  }
  let t119;
  if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
    t119 = <br />;
    $[119] = t119;
  } else {
    t119 = $[119];
  }
  let t120;
  if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
    t120 = <br />;
    $[120] = t120;
  } else {
    t120 = $[120];
  }
  let t121;
  if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
    t121 = <Container>{t0}{t1}<Row className="pt-3 pb-3"><Col><>{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t21}{t22}{t24}{t26}{t27}{t28}{t29}{t30}{t31}{t32}{t33}{t34}{t35}{t36}{t37}{t38}{t39}{t40}{t41}{t42}{t43}{t44}{t45}{t46}{t47}{t48}{t49}{t50}{t51}{t52}{t53}{t55}{t56}{t58}{t59}{t60}{t61}{t62}{t63}{t64}{t65}{t66}{t67}{t68}{t69}{t70}{t71}{t72}{t73}{t74}{t75}{t76}{t77}{t78}{t79}{t80}{t81}{t82}{t83}{t84}{t85}{t86}{t87}{t88}{t89}{t90}{t91}{t92}{t93}{t94}{t95}{t96}{t97}{t98}{t99}{t102}{t103}{t104}{t105}{t106}{t107}{t108}{t109}{t110}{t111}{t112}{t113}{t114}{t115}{t116}<ul>{t117}<li>Mail:{t118}6529 Collection LLC{t119}2810 N Church St{t120}#76435 Wilmington, DE 19802-4447<br />United States of America</li></ul></></Col></Row></Container>;
    $[121] = t121;
  } else {
    t121 = $[121];
  }
  return t121;
}